import * as actions from "../actions/actionTypes";

const initialState = {
  error: null,
  loading: false,
  updatePassword: {
    error: null,
    loading: false,
  },
  authAlerts: [],
};

// HELPER FUNCTIONS
const authClear = (state) => {
  return {
    ...state,
    ...initialState,
  };
};

const authStart = (state) => {
  return { ...state, loading: true };
};

const authEnd = (state) => {
  return { ...state, loading: false };
};

const authFail = (state, payload) => {
  return { ...state, error: payload };
};

const authSuccess = (state) => {
  return { ...state, error: false };
};

const updatePasswordStart = (state) => {
  return {
    ...state,
    updatePassword: { ...state.updatePassword, loading: true },
  };
};

const updatePasswordSuccess = (state) => {
  return {
    ...state,
    updatePassword: {
      ...state.updatePassword,
      loading: false,
      error: false,
      isUpdatedSuccessfully: true,
    },
  };
};

const updatePasswordFail = (state, payload) => {
  return {
    ...state,
    updatePassword: {
      ...state.updatePassword,
      loading: false,
      error: payload,
    },
  };
};

const setAlerts = (state, payload) => {
  return {
    ...state,
    authAlerts: [...state.authAlerts, payload],
  };
};

const clearAlerts = (state, payload) => {
  return {
    ...state,
    storeAlerts: payload,
  };
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.AUTH_CLEAR:
      return authClear(state);

    case actions.AUTH_START:
      return authStart(state);

    case actions.AUTH_END:
      return authEnd(state);

    case actions.AUTH_FAIL:
      return authFail(state, payload);

    case actions.AUTH_SUCCESS:
      return authSuccess(state);

    case actions.UPDATE_PASSWORD_START:
      return updatePasswordStart(state);

    case actions.UPDATE_PASSWORD_SUCCESS:
      return updatePasswordSuccess(state);

    case actions.UPDATE_PASSWORD_FAIL:
      return updatePasswordFail(state, payload);

    case actions.SET_AUTH_ALERT:
      return setAlerts(state, payload);

    case actions.CLEAR_AUTH_ALERT:
      return clearAlerts(state, payload);

    default:
      return state;
  }
};
